// antd
import { Fragment } from "react";
// uirouter
import { UIRouter, UIView, pushStateLocationPlugin } from "@uirouter/react";
// rourters and states
import states from '../states'
import config from '../states/config'

const propsUIRouter = {
    config,
    states,
    plugins: [pushStateLocationPlugin],
    children: <UIView />
}

export default function App() {
    return (
        <Fragment>
            <UIRouter {...propsUIRouter} />
        </Fragment>
    )
}